<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <iframe v-if="iframeUrl" :src="iframeUrl" sandbox="allow-scripts allow-same-origin allow-forms allow-popups" referrerpolicy="no-referrer" style="width: 100%; height: 100%; border: 0"></iframe>
  </div>
</template>

<script>

import components from '~/lib/components'

export default {
  data () {
    return {
      url: ''
    }
  },
  mixins: [components],
  computed: {
    data () {
      return (this.component.data !== '' ? JSON.parse(this.component.data) : false)
    },
    iframeUrl () {
      // https pages of other sites only: a javascript: URL or a page of this app would run with the POS session
      try {
        const url = new URL(String(this.data && this.data.url || ''))
        if (url.protocol !== 'https:' || (import.meta.client && url.origin === window.location.origin)) {
          return ''
        }
        return url.href
      } catch {
        return ''
      }
    }
  }
}

</script>